import {
  API_REQUEST,
  API_REQUEST_END,
  ERROR_RESPONSE,
  SET_LOADING,
  SET_OPEN_MENU_DRAWER,
  SUCCESS_RESPONSE,
} from '../actionTypes';

const initialState = {
  isLoading: false,
  error: false,
  message: '',
  openMenuDrawer: false,
};

export const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case API_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: false,
        message: '',
      };
    case API_REQUEST_END:
      return {
        ...state,
        isLoading: false,
      };
    case SUCCESS_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: action.payload,
      };
    case ERROR_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: true,
        message: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_OPEN_MENU_DRAWER:
      return {
        ...state,
        openMenuDrawer: action.payload,
      };
    default:
      return state;
  }
};
